import { createContext, useContext } from 'react';

export interface AssistantPatient {
  id: string;
  /** Affiché à l'utilisateur seulement : jamais envoyé à l'IA. */
  label: string;
}

export interface AssistantControls {
  open: (patient?: AssistantPatient | null) => void;
}

export const AssistantContext = createContext<AssistantControls>({ open: () => undefined });

export function useAssistantControls(): AssistantControls {
  return useContext(AssistantContext);
}
